import { types, getEnv, applySnapshot } from 'mobx-state-tree';
import { SubscriptionList } from './SubscriptionList';
import { View } from './View';
//import { MsgAmount } from './MsgAmount';
//import { CallsAmount } from './CallsAmount';
import { UserProps } from './UserProps';
import { Agent } from '../stores/agent';
import { BrandingProps } from './BrandingProps';


export const LoggedinUser = types
    .model('LoggedinUser', {
        firstName: types.string,
        lastName: types.string,
        isauthenticated: types.boolean,
        isRememberMe: types.boolean,
        isLoggingIn: types.boolean,
        properties: UserProps,
        subscriptions: types.optional(SubscriptionList, {}),
        view: types.optional(View, {}),
        isLoading: types.boolean,
        branding: BrandingProps,
    })
    .views(self => ({
        get fetch() {
            return getEnv(self).fetch;
        },
        get alert() {
            return getEnv(self).alert;
        },
        get fullName() {
            return self.firstName + ' ' + self.lastName;
        },
        get isSubscriber() {
            let subscriber = false;
            if (self.subscriptions !== undefined) {
                if (self.subscriptions.items.length > 0) {
                    subscriber = true;
                }
            }
            return subscriber;
        }
    }))
    .actions(self => ({
        // setUser(fname: string, lname: string) {
        //     self.firstName = fname;
        //     self.lastName = lname;
        //     self.isauthenticated = true;
        // },
        clearUser() {
            self.firstName = '';
            self.lastName = '';
            self.subscriptions.clear();
            self.properties.clearProps();
            self.isauthenticated = false;
        },
        login(form: string) {
            if (form !== 'initiatelogin') {
                self.isLoading = true;
            }
            let agent: Agent = Agent.GetAgent;
            self.properties.errors = '';
            self.isLoggingIn = true;
            console.log('/Account/' + form + ' { "user": "' + self.properties.loginname + '"}');
            agent.PostAuth('/Account/' + form, { user: self.properties.loginname, password: self.properties.password });
            //agent.PostAuth('/Account/Login', { user: self.properties.loginname, password: self.properties.password });
            //agent.PostAuth('/Account/InitiateLogin', { user: self.properties.loginname, password: self.properties.password });
            //agent.PostAuth('/Account/InitiateLogin', self.properties.loginname);
        },
        loggedinOK(data) {
            console.log('loggedinOK');
            let agent: Agent = Agent.GetAgent;
            if (self.view.loginForm !== 'initiatelogin') {
                self.isLoading = true;
                //self.isauthenticated = true;
                if (data.API_Token) {
                    if (self.isRememberMe) {
                        localStorage.setItem('msat', data.API_Token);
                    }
                    sessionStorage.setItem('msat', data.API_Token);
                    agent.GetAll();
                }
            } else {
                self.properties.password = '';
                if (data.FirstName) {
                    self.firstName = data.FirstName;
                }
                if (data.FirstName) {
                    self.lastName = data.LastName;
                }
                self.view.setLoginForm('confirmlogin');
            }
        },
        loggedinFail(err: string) {
            self.isLoading = false;
            self.isLoggingIn = false;
            console.log(err);
            self.properties.setErrors(err);
            if (self.view.loginForm === 'confirmlogin') {
                self.view.setLoginForm('initiatelogin');
            }
        },
        setRememberMe(flag: boolean) {
            self.isRememberMe = flag;
        },
        getallOK(data) {
            console.log('GetAll OK');
            self.firstName = data.firstName;
            self.lastName = data.lastName;
            self.properties.setProps(data);
            self.subscriptions.clear();
            if (data.subscriptions.items != null && data.subscriptions.items.length > 0) {
                self.subscriptions.add(data.subscriptions.items[0]);
            }
            self.isauthenticated = true;
            self.isLoading = false;
            self.isLoggingIn = false;
            if (data.subscriptions.items != null && data.subscriptions.items.length > 0) {
                console.log('GetAll OK subscriber');
                self.view.openHomePage();
                // Try to update surf amount from server (Telenor)
                let agent: Agent = Agent.GetAgent;
                agent.GetSurfAmount();
            } else {
                console.log('GetAll Not subscriber');
                // self.properties.setErrors("Du har inte Tellit abonnemang");
                self.view.openNotSubscriberPage();
            }

        },
        logout() {
            //Clear data
            self.firstName = '';
            self.lastName = '';
            self.subscriptions.clear();
            self.properties.clearProps();
            self.isauthenticated = false;
            self.isRememberMe = false;
            self.isLoggingIn = false;
            //Remove cached tokens
            sessionStorage.removeItem('msat');
            localStorage.removeItem('msat');
            //Goto login dialog
            self.view.setLoginForm('initiatelogin');
            self.view.openLoginPage();
        },
        comError(err: string) {
            console.log(err);
            self.view.openNoDataFound();
        }
    }));

export default LoggedinUser;


// WEBPACK FOOTER //
// ./src/models/LoggedinUser.ts